import { privateGet, privatePost } from "../clients/createPrivateClient";
import {
  CPGetCustomerUserQueryResult,
  CPGetLinkedContactPeopleQueryResult,
  CustomerUserAcceptInvitationRequest,
  CustomerUserLoginResult,
  PasswordToChange,
} from "../models/unified";

export default {
  getLoggedUser: async () => {
    const result = await privateGet<CPGetCustomerUserQueryResult>(
      "customerPortal/customerUser/v2/loggedCustomerUser",
    );

    return result;
  },
  logout: async (refreshTokenId: string) => {
    const result = await privatePost<undefined>(
      "customerPortal/customerUser/v2/logout",
      { refreshTokenId },
    );

    return result;
  },
  acceptInvite: async (data: CustomerUserAcceptInvitationRequest) => {
    const result = await privatePost<CustomerUserLoginResult>(
      "customerPortal/customerUser/v2/acceptInvitation",
      data,
    );

    return result;
  },
  changeCustomer: async (customerId: string) => {
    const result = await privatePost<CustomerUserLoginResult>(
      "customerPortal/customerUser/v2/changeCustomer",
      { customerId },
    );

    return result;
  },
  changePassword: async (values: PasswordToChange) => {
    const result = await privatePost<undefined>(
      "customerPortal/customerUser/v2/changePassword",
      values,
    );

    return result;
  },
  getLinkedContactPeople: async () => {
    const result = await privateGet<CPGetLinkedContactPeopleQueryResult>(
      "customerPortal/customerUser/v2/LinkedContactPeople",
    );

    return result;
  },
};
